import Vue from 'vue'
import VueRouter from 'vue-router'
// importing views
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import MyProfile from '../views/Profile.vue'
import Billing from '../views/BillingInformation.vue'
import Tickets from '../views/Tickets.vue'
import Services from '../views/Services.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import PaymentCompleted from '../views/PaymentCompleted.vue'
// importing components
import NotFound from '../components/NotFound.vue'
import PaymentError from '../components/Cards/PaymentErrorCard.vue'
// importing modules
import store from '@/store/modules';
import Verify from "@/views/Verify.vue";

// using vue router for the routes
Vue.use(VueRouter)

// initializing all routes
const routes = [
    {
        path: "*",
        name: 'Not Found',
        component: NotFound
    },
    {
        path: "/",
        redirect: "/login"
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        props: true
    },
    {
        path: '/verify',
        name: 'Verify',
        component: Verify,
        props: true,
        meta: {requiresAuth: true},
    },
    {
        path: '/paymentCompleted',
        name: 'Payment Completed',
        component: PaymentCompleted,
        props: true,
    },
    {
        path: '/paymentError',
        name: 'Payment Error',
        component: PaymentError,
        props: true,
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {requiresAuth: true},
    },
    {
        path: '/profile',
        name: 'My Profile',
        component: MyProfile,
        meta: {requiresAuth: true},
    },
    {
        path: '/billing',
        name: 'Billing Information',
        component: Billing,
        meta: {requiresAuth: true},
    },
    {
        path: '/tickets',
        name: 'Trouble Tickets',
        component: Tickets,
        meta: {requiresAuth: true},
    },
    {
        path: '/services',
        name: 'Services',
        component: Services,
        meta: {requiresAuth: true},
    },
    {
        path: '/forgotPassword',
        name: 'Forgot Password',
        component: ForgotPassword,
    },
    {
        path: "/captive",
        name: "Captive",
        component: () => import("../views/CaptiveView.vue"),
    },
    {
        path: "/captive/subscribe",
        name: "Captive Subscribe",
        component: () => import("../views/CaptiveToSubscribe.vue"),
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history', // remove # from url
    routes
});

// Vue.config.errorHandler = function (err, vm, info) {
//     console.log("error message", [err, vm, info]);
//     // console.log("status", err.response.status);
//     if (err.response.status === 433) {
//         store.dispatch('unverify');
//     } else if (err.response.status === 403) {
//         store.dispatch('unverify');
//         store.dispatch('logout');
//     }
// }

// this is where the system controls when to let the customer can enter the
// application and when not
router.beforeEach((to, from, next) => {
    var now = new Date();
    // checks if the to route name is Forgot Password to let the
    // customer go to the next route
    if (to.name === 'Forgot Password' || to.name === 'Captive' || to.name === 'Captive Subscribe') {
        next()
        return
    }
    // checks if a user is logged in, if not it will redirect to login route
    if (!store.getters.isAuthenticated && to.name !== 'Login') {
        next('/login')
        return
    }
    // check if user has verified their 2fa login
    if (store.getters.isAuthenticated && !store.getters.isVerified && to.name !== 'Verify') {
        next({
            name: "Verify",
            params:
                {
                    email: store.getters.email
                }
        })
        return
    }
    // checks if session is expired, if it is, it will redirect to login page
    if (now.getTime() > store.getters.expires_at && to.name !== 'Login') {
        store.dispatch('logout')
        next('/login')
        return
    }
    // checks if customer is authenticated, if it is, it will redirect to dashboard
    if (store.getters.isAuthenticated && to.name === 'Login') {
        next('/dashboard')
        return
    }
    // if none of the if statements are fulfilled, customer is going to next route
    next()
})

export default router
